import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    if (user.role === 'student') return <Navigate to="/dashboard" replace />;
    if (user.role === 'super_admin') return <Navigate to="/admin" replace />;
    if (user.role === 'counselor') return <Navigate to="/counselor" replace />;
    if (user.role === 'agent') return <Navigate to="/agent" replace />;
    if (user.role === 'rep1' || user.role === 'rep2') return <Navigate to="/representative" replace />;
    if (user.role === 'rep3') return <Navigate to="/partner" replace />;
  }

  return children;
};
